import { attribute, create, clickable, collection, isPresent, text, triggerable, visitable, fillable } from 'ember-cli-page-object';
import ModalAction from 'vagrant/test-support/pages/components/modal/action';
import ModalConfirm from 'core/test-support/pages/components/modal-confirm';
import flashMessage from 'core/test-support/pages/components/flash-message';
export default create({
  visit: visitable('/private/registries/:registry/boxes/:box/versions/:version'),
  title: text('[data-test-title]'),
  subtitle: text('[data-test-subtitle]'),
  manage: clickable('[data-test-manage-version-trigger]'),
  isManageable: isPresent('[data-test-manage-version]'),
  manageActions: collection('[data-test-manage-version] [data-test-manage-action]', {
    action: attribute('data-test-manage-action')
  }),
  async action(name) {
    const action = this.manageActions.findOneBy('action', name);
    if (!action) throw new Error(`No action with name ${name}`);
    await action.click();
  },
  hasAction(name) {
    return !!this.manageActions.toArray().find(obj => obj.action === name);
  },
  shortDescription: text('[data-test-short-description]'),
  providers: collection('[data-test-providers] > li', {
    name: text('h3'),
    isEditing: isPresent('input[name="provider-name"]'),
    editName: fillable('input[name="provider-name"]'),
    submitNameChange: triggerable('keydown', 'input[name="provider-name"]', {
      eventProperties: {
        key: 'Enter'
      }
    }),
    cancelNameChange: triggerable('keydown', 'input[name="provider-name"]', {
      eventProperties: {
        key: 'Escape'
      }
    }),
    manage: clickable('[data-test-manage-provider-trigger]'),
    isManageable: isPresent('[data-test-manage-provider]'),
    manageActions: collection('[data-test-manage-provider] [data-test-provider-action]', {
      action: attribute('data-test-provider-action')
    }),
    async action(name) {
      const action = this.manageActions.findOneBy('action', name);
      if (!action) throw new Error(`No action with name ${name}`);
      await action.click();
    },
    hasAction(name) {
      return !!this.manageActions.toArray().find(obj => obj.action === name);
    },
    isEmpty: isPresent('div + em'),
    architectures: collection('> ol > li', {
      type: text('span > span'),
      url: text('[data-test-description="external"]'),
      hasUrl: isPresent('[data-test-description="external"]'),
      size: text('[data-test-description="hosted"]'),
      hasSize: isPresent('[data-test-description="hosted"]'),
      manage: clickable('[data-test-manage-architecture-trigger]'),
      isManageable: isPresent('[data-test-manage-architecture]'),
      manageActions: collection('[data-test-manage-architecture] [data-test-architecture-action]', {
        action: attribute('data-test-architecture-action')
      }),
      async action(name) {
        const action = this.manageActions.findOneBy('action', name);
        if (!action) throw new Error(`No action with name ${name}`);
        await action.click();
      },
      hasAction(name) {
        return !!this.manageActions.toArray().find(obj => obj.action === name);
      }
    })
  }),
  deleteModal: ModalAction('[data-test-version-delete-modal]', {
    ...ModalConfirm
  }),
  releaseModal: ModalAction('[data-test-version-release-modal]', {
    ...ModalConfirm
  }),
  revokeModal: ModalAction('[data-test-version-revoke-modal]', {
    ...ModalConfirm
  }),
  deleteProviderModal: ModalAction('[data-test-provider-delete-modal]', {
    ...ModalConfirm,
    body: text('[data-test-body-message]')
  }),
  deleteArchitectureModal: ModalAction('[data-test-architecture-delete-modal]', {
    ...ModalConfirm,
    body: text('[data-test-body-message]')
  }),
  flash: flashMessage
});